export default {"src":"/hedera/_next/static/media/fantom.874a1ac6.svg","height":14,"width":8};